document.addEventListener('DOMContentLoaded', function () {
    function insertReviewsLink() {
        debugger;
        const carousel = document.querySelector('.jdgm-cards-carousel');
        const target = document.querySelector('#judgeme_product_reviews');

        if (!carousel || !target) return false;

        if (carousel.querySelector('.custom-reviews-link')) return true;

        const link = document.createElement('a');
        link.textContent = 'Read all reviews';
        link.href = '#judgeme_product_reviews';
        link.className = 'custom-reviews-link btn btn--underline';

        carousel.appendChild(link);

        return true;
    }
    const interval = setInterval(() => {
        if (insertReviewsLink()) {
            clearInterval(interval);
        }
    }, 100);
});